/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/**
 * This file was auto-generated by `yarn generate-openapi-contracts`.
 * Do not make direct changes to the file.
 */

import { fetchAsJson, applyParameters } from '@modules/query/helpers'
import type { Exact } from '@modules/ts-essentials'

import type { operations, components } from './types'

// GET /api/v1/cloud-connected/clusters
// ts-unused-exports:disable-next-line
export const listClusters = async () =>
  fetchAsJson<components['schemas']['ClusterList']>('/api/v1/cloud-connected/clusters', {
    method: 'GET',
  })

// POST /api/v1/cloud-connected/clusters
// ts-unused-exports:disable-next-line
export const createCluster = async <
  T = operations['createCluster']['requestBody'] extends undefined
    ? undefined
    : Exclude<operations['createCluster']['requestBody'], undefined>['content']['application/json'],
>(args: {
  queryParameters?: operations['createCluster']['parameters']['query']
  body: Exact<
    T,
    operations['createCluster']['requestBody'] extends undefined
      ? undefined
      : Exclude<
          operations['createCluster']['requestBody'],
          undefined
        >['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['ClusterCreated'] | components['schemas']['ClusterCreated']>(
    applyParameters('/api/v1/cloud-connected/clusters', args),
    {
      method: 'POST',
      body: JSON.stringify(args.body),
    },
  )

// GET /api/v1/cloud-connected/clusters/{id}
// ts-unused-exports:disable-next-line
export const getCluster = async (args: {
  pathParameters: operations['getCluster']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['Cluster']>(
    applyParameters('/api/v1/cloud-connected/clusters/{id}', args),
    {
      method: 'GET',
    },
  )

// DELETE /api/v1/cloud-connected/clusters/{id}
// ts-unused-exports:disable-next-line
export const deleteCluster = async (args: {
  pathParameters: operations['deleteCluster']['parameters']['path']
}) =>
  fetchAsJson<void>(applyParameters('/api/v1/cloud-connected/clusters/{id}', args), {
    method: 'DELETE',
  })

// PATCH /api/v1/cloud-connected/clusters/{id}
// ts-unused-exports:disable-next-line
export const patchCluster = async <
  T = operations['patchCluster']['requestBody'] extends undefined
    ? undefined
    : Exclude<operations['patchCluster']['requestBody'], undefined>['content']['application/json'],
>(args: {
  pathParameters: operations['patchCluster']['parameters']['path']
  body: Exact<
    T,
    operations['patchCluster']['requestBody'] extends undefined
      ? undefined
      : Exclude<operations['patchCluster']['requestBody'], undefined>['content']['application/json']
  >
}) =>
  fetchAsJson<components['schemas']['ClusterPatched']>(
    applyParameters('/api/v1/cloud-connected/clusters/{id}', args),
    {
      method: 'PATCH',
      body: JSON.stringify(args.body),
    },
  )

// POST /api/v1/cloud-connected/clusters/{id}/apikey/_revoke-pending
// ts-unused-exports:disable-next-line
export const revokePendingClusterAPIKeys = async (args: {
  pathParameters: operations['revokePendingClusterAPIKeys']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/cloud-connected/clusters/{id}/apikey/_revoke-pending', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/cloud-connected/clusters/{id}/apikey/_rotate
// ts-unused-exports:disable-next-line
export const rotateClusterAPIKey = async (args: {
  pathParameters: operations['rotateClusterAPIKey']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['ClusterAPIKey']>(
    applyParameters('/api/v1/cloud-connected/clusters/{id}/apikey/_rotate', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/cloud-connected/clusters/{id}/apikey/{service}/_revoke-pending
// ts-unused-exports:disable-next-line
export const revokePendingServiceAPIKeys = async (args: {
  pathParameters: operations['revokePendingServiceAPIKeys']['parameters']['path']
}) =>
  fetchAsJson<void>(
    applyParameters('/api/v1/cloud-connected/clusters/{id}/apikey/{service}/_revoke-pending', args),
    {
      method: 'POST',
    },
  )

// POST /api/v1/cloud-connected/clusters/{id}/apikey/{service}/_rotate
// ts-unused-exports:disable-next-line
export const rotateServiceAPIKey = async (args: {
  pathParameters: operations['rotateServiceAPIKey']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['RotatedServiceAPIKey']>(
    applyParameters('/api/v1/cloud-connected/clusters/{id}/apikey/{service}/_rotate', args),
    {
      method: 'POST',
    },
  )

// GET /api/v1/cloud-connected/organizations/{organization_id}/subscription
// ts-unused-exports:disable-next-line
export const getSubscription = async (args: {
  pathParameters: operations['getSubscription']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['Subscription']>(
    applyParameters('/api/v1/cloud-connected/organizations/{organization_id}/subscription', args),
    {
      method: 'GET',
    },
  )

// GET /api/v1/cloud-connected/organizations/{organization_id}/terms-and-conditions
// ts-unused-exports:disable-next-line
export const getTermsAndConditions = async (args: {
  pathParameters: operations['getTermsAndConditions']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['TermsAndConditionsInfo']>(
    applyParameters(
      '/api/v1/cloud-connected/organizations/{organization_id}/terms-and-conditions',
      args,
    ),
    {
      method: 'GET',
    },
  )

// POST /api/v1/cloud-connected/organizations/{organization_id}/terms-and-conditions/_accept
// ts-unused-exports:disable-next-line
export const acceptTermsAndConditions = async (args: {
  pathParameters: operations['acceptTermsAndConditions']['parameters']['path']
}) =>
  fetchAsJson<components['schemas']['TermsAndConditionsInfo']>(
    applyParameters(
      '/api/v1/cloud-connected/organizations/{organization_id}/terms-and-conditions/_accept',
      args,
    ),
    {
      method: 'POST',
    },
  )
